module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach2",
      "title": "2. A Harsh and Senseless Hurdle"
    }
  }, [_c('p', {
    staticClass: "h2c"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2c1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch2"
    }
  }, [_vm._v("A Harsh and Senseless Hurdle")])]), _vm._v(" "), _c('p', {
    staticClass: "h3ca"
  }, [_vm._v("PLUS C’EST LA MEME CHOSE")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Back in 2007, John Merrow wrote an article for the "), _c('i', [_vm._v("New York Times")]), _vm._v(" that focused on a student at LaGuardia Community College named Krystal Jenkins, who aspired to become "), _c('a', {
    attrs: {
      "id": "ch2en1"
    }
  }), _vm._v("a veterinary technician. Seven years later, in 2014, Ginia Bellafante, writing for the same newspaper, visited the same college. Her article’s center was Vladimir de Jesus, who hoped to "), _c('a', {
    attrs: {
      "id": "ch2en2"
    }
  }), _vm._v("major in studio art. The stories were strikingly similar. They told of students denied a chance for further education due to crushing mathematics requirements.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I love animals,” Krystal Jenkins said. Her fetching way with them spurred her desire to become a veterinary technician. But before she was allowed into even introductory classes, her college demanded that she pass a course in linear and quadratic equations. Sadly, Krystal failed it twice, and was told she couldn’t take it again. “It all came crashing down,” she said, as she left the college for good. Not a single veterinarian or technician with whom I’ve spoken could recall a need for that level of algebra. Quite obviously, numbers figure in prescriptions, inoculations, and treatments. But accurate arithmetic suffices.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Vladimir de Jesus had been allowed a third try in a similar LaGuardia class, featuring assignments like the cosine of pi over "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("two. But he found it “a stainless-steel wall and there’s no way up it, around it, or under it.” Nor was he alone; 40 percent of his classmates also failed. Vladimir has joined Krystal in a growing population of involuntary alumni, the victims of a one-size-for-all ideology. He has turned to freelance tattooing.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3c"
  }, [_vm._v("DISMAYING STATISTICS")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In the percentage of its young people who finish high school, the United States "), _c('a', {
    attrs: {
      "id": "ch2en3"
    }
  }), _vm._v("ranked twenty-second out of thirty developed countries surveyed by the Organization for Economic Cooperation and Development in 2013, behind Hungary, Slovenia, and Chile. The United States did a bit better on college completion: it was "), _c('a', {
    attrs: {
      "id": "ch2en4"
    }
  }), _vm._v("twelfth amid thirty-two nations, this time after Luxembourg, Israel, and New Zealand. We have more colleges per capita, but fewer of our students stay to finish a full program.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In our high schools, one in five of our ninth-graders doesn’t make it to a diploma. In New Mexico and Georgia, 28 percent aren’t in the procession. In Nevada, it’s 29 percent. That means that each year a million American teenagers start life without a basic national credential. Of those who do graduate and enter college, only a little over half—56 percent—emerge with a bachelor’s degree. America’s educational highway is littered with dropouts at every mile, a human roadkill that doesn’t have to happen.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("A lot of reasons have been cited for these shortfalls in our education system. We’re a far larger country than Portugal. We’re more complicated than Iceland. We have higher pregnancy rates among teens than many developed countries. We are extremely punitive and put more of our young people in prison. Our poverty rate is the highest in the developed world.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I believe these factors may all play a role, though I also feel it is within our power to address and remedy most of them. That said, this book will explore another, "), _c('i', [_vm._v("academic")]), _vm._v(" reason our efforts at universal education fall so conspicuously short: our insistence on heedless and needless mathematics requirements. Research "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("by Lynn Arthur Steen of St. Olaf’s College shows that “mathematics is the academic subject that "), _c('a', {
    attrs: {
      "id": "ch2en5"
    }
  }), _vm._v("students most often fail.” Jo Boaler at Stanford University goes a step further: “currently, "), _c('a', {
    attrs: {
      "id": "ch2en6"
    }
  }), _vm._v("more than half of all U.S. students fail mathematics.” Nor should this surprise us. History, literature, and biology all touch base with realities we know. Compared with other subjects, mathematics represents an alien world, an enigmatic orbit of abstractions. To be sure, most pupils eventually squeak through. But the pass rate for mathematics is the lowest of all departments and disciplines.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Still, in the name of college preparation and academic rigor, each year sees even more mathematics being imposed. "), _c('a', {
    attrs: {
      "id": "ch2en7"
    }
  }), _vm._v("As recently as 1982, only 55 percent of high school graduates had a course in algebra, and 47 percent had taken geometry. Today, 88 percent who finish have had a geometry course, and 76 percent have had two years of algebra.")]), _vm._v(" "), _c('p', {
    staticClass: "h3c"
  }, [_vm._v("HIGH SCHOOL: ALGEBRA AND ATTRITION")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Shirley Bagwell, a high school mathematics teacher in Tennessee—who has written articles with titles such as “When Barbie Drops Algebra” and “Is Algebra Hurting America?”—warns that “to expect all students to master algebra will cause "), _c('a', {
    attrs: {
      "id": "ch2en8"
    }
  }), _vm._v("more students to drop out.” Most who get through, she adds, “will avoid mathematics forever and remember the subject as a nightmare.” She is seconded by Teresa George, a veteran Arkansas teacher: “Some students are never going to pass algebra, and "), _c('a', {
    attrs: {
      "id": "ch2en9"
    }
  }), _vm._v("then you’ve lost them.” The late Gerald Bracey, another classroom veteran, adds that “forcing everyone to take algebra is more likely to "), _c('a', {
    attrs: {
      "id": "ch2en10"
    }
  }), _vm._v("turn kids off mathematics and even off school altogether.” Extensive research supports what they are saying. (Here and elsewhere, I and others use algebra as a shorthand for the usual mathematics menu in secondary education. In fact, geometric parabolics can be just as daunting as algebraic vectors.)")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("A report entitled “Locating the Dropout Crisis,” by Robert Balfanz and Nettie Legters of Johns Hopkins University, found that "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch2en11"
    }
  }), _vm._v("“failing ninth-grade algebra is the reason many students are left back in ninth grade, which in turn is the greatest risk factor for dropping out.” A study of Los Angeles schools, supervised by David Silver of the University of California, was more precise: “on average, 65 percent of students in any given Algebra I class "), _c('a', {
    attrs: {
      "id": "ch2en13"
    }
  }), _vm._v("in the district will fail.” Geometry fared somewhat better, with only half—51—percent failing.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Nor is it only teachers who hand out failing grades. Before the advent of the Common Core, several states had their own comprehensive tests. Prodded by the misnamed No Child Left Behind law, they "), _c('a', {
    attrs: {
      "id": "ch2en12"
    }
  }), _vm._v("installed “exit” exams, which all students had to pass to secure a diploma, pretty much ensuring that at least some children would be left behind. By 2013, at least nineteen states had mandated such exams and had reported results. Their failure rates for mathematics were arresting. In Minnesota, 43 percent of students taking the mathematics test didn’t pass. In Nevada, it was 57 percent; Washington, 61 percent; Arizona, 64 percent. And these are students who, at least until the test, had made it to their senior year. In all but one of the nineteen states, the highest failures were in mathematics, not some other subject. This happened not because that many young people were indolent or indifferent. Rather, they hadn’t mastered equations even educated parents have forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("As of this writing, most states have signed on to the Common Core, with its plans for uniform tests and parallel scoring systems. Their next step is to decide if they want to require specific Core scores for high school graduation. For example, will identical grades for “passing” or “proficient” be used nationally? Since the Core’s “standards” include advanced algebra, a state like Alabama will have to choose whether to use the same passing score as, say, North Dakota. If Alabama does, it may find a majority of its high school seniors leaving without diplomas.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Each year also sees more states requiring a second year of algebra. Often the impetus comes from legislators and business groups, hardly any of whom have a notion of what is taught in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("actual classrooms. Joseph Rosenstein, a Rutgers University mathematics professor, can find no rationale for imposing such specialized concepts on everyone: “It is hard to make the case that topics like complex numbers, rational exponents, systems of linear inequalities, and inverse functions are needed by all students.” Rosenstein asks these lawmakers and executives, “When was the last time you "), _c('a', {
    attrs: {
      "id": "ch2en14"
    }
  }), _vm._v("needed to factor trinomials?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("We know that students’ grades and scores tend to correlate with their parents’ social and economic status. (There’s at least one exception to this rule, which I’ll touch on later, with respect to ethnicity.) As we might expect, more pupils who fail are from low-income homes. But that’s not the critical issue with mathematics. It is a hurdle for all kinds of students, both disadvantaged and affluent, as well as from all ethnic origins. In New Mexico’s mathematics exams, 43 percent of white pupils fell below proficient, as did 39 percent in Tennessee. Nor is this surprising. We all know professional families where one daughter is a mathematics whiz, while her sister turns semi-suicidal over geometry. Still, with intensive (and often expensive) coaching, the second child may manage a passing grade.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Enter the coaching industry, a mainstay when academic opportunities hinge on multiple-choice points. A 2015 estimate found corporations like Kaplan and Princeton Review taking in "), _c('a', {
    attrs: {
      "id": "ch2en15"
    }
  }), _vm._v("$7 billion for classes and personal sessions, with at least another $3 billion going to freelancers. Needless to say, the bulk of test preparation is for mathematics. It’s hard to see a demand for social studies tutorials.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Colleen Oppenzato, a tutor who works from her Brooklyn apartment, told me she spends most of her time with students explaining how the test is structured and teaching test-taking techniques, rather than the mathematics itself. One such technique is “back solving,” where the student starts by examining the alternative answers rather than the actual question. "), _c('a', {
    attrs: {
      "id": "ch2en16"
    }
  }), _vm._v("“With shrewd tutoring,” she told me,” someone knowing no mathematics at all could get a four hundred on the SAT.” True, that’s not "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("an auspicious score. But it’s an indication of how far test-taking technique can affect performance.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("A survey by a local newspaper in suburban Pelham, just outside New York City, found that over half of the families were "), _c('a', {
    attrs: {
      "id": "ch2en17"
    }
  }), _vm._v("paying for such aid. And this was for students already benefiting from an elite school system, with a well-credentialed faculty. It adds up to an admission that even well-performing schools cannot fully prepare their pupils for the mathematics marathon, which each year moves the starting line to an earlier age. If suburbs such as Pelham, with a median household income of $114,444 (about double the national figure), find a need for tutoring, imagine the deficits in the rest of the country.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Mathematics hurdles underscore and contribute to the country’s social divide. On one side are families who can afford to reside in well-endowed districts with smaller classes and attentive teachers, supplemented by private classes and coaching. Kaplan and Princeton Review ask about $800 for ten small-group Saturday-morning sessions. On the other side, a Manhattan tutoring service wants $700 an hour for one-on-one tutoring, although for that they come to your home.")]), _vm._v(" "), _c('p', {
    staticClass: "h3c"
  }, [_vm._v("CLOSING COLLEGE DOORS")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Whether everyone should attend college has always been a contentious question. (Much turns on when; perhaps not everyone should start at eighteen.) If we want to keep opportunities open, admissions standards become an issue. So in the name of rigor, most colleges now want all applicants to arrive with at least three years of mathematics, including those rational exponents and linear inequalities taught in the second year of algebra. Most colleges also require respectable scores on the SAT or ACT, which each include problems involving complex numbers and inverse functions.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The twenty-three campuses of the California State University system, stretching from Fresno to Stanislaus, aren’t Stanford or "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("Berkeley. Even so, to be considered by any of them, students need to have mastered the full mathematics menu, including two years of algebra. So students who show promise in art history or postmodern criticism won’t even have their applications opened if they faltered in geometry. "), _c('a', {
    attrs: {
      "id": "ch2en18"
    }
  }), _vm._v("The consequences are dismaying. In 2012, only 38 percent of California’s high school graduates—who actually won diplomas—were deemed eligible for branches of Cal State. Graduates classified as Caucasian did somewhat better than the overall average, but not by much. Only 45 percent had transcripts deemed worth considering by their state’s public colleges. Anthony Carnevale and Donna Desrochers ask, “are mathematics courses "), _c('a', {
    attrs: {
      "id": "ch2en19"
    }
  }), _vm._v("creating artificial barriers to college entry?” By now, the answer is obvious.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("We often hear that rejected applicants can start at two-year colleges and continue with their education if they do well there. This too is largely a myth. A 2013 study by the Century Foundation indeed found that over 80 percent of students starting in community colleges "), _c('a', {
    attrs: {
      "id": "ch2en20"
    }
  }), _c('i', [_vm._v("wanted")]), _vm._v(" to proceed to at least a bachelor’s degree. Sadly, a follow-up six years later found that only 12 percent had actually been able to fulfill that aspiration. What deterred them? By this time, the reason should be evident. Once admitted to two-year schools, they find themselves in a mathematics morass.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In May of 2014, Paul Tough wrote an incisive analysis, “Who Gets to Graduate?” His first answer was that it wasn’t community college students. On arrival, fully two-thirds of them are "), _c('a', {
    attrs: {
      "id": "ch2en21"
    }
  }), _vm._v("consigned to remedial mathematics classes, for which they get no credit, but which they must pass in order to enroll in any other courses. It isn’t that they can’t do long division, construct ratios, or interpret statistical tables. No, the colleges want them proficient up to trigonometry, before they can enter programs in commercial art or cosmetology.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("At Pennsylvania’s Montgomery County Community College, half of the students taking required mathematics courses end with failing grades. A study of twenty-seven two-year colleges nationwide found that less than a quarter of the students pursuing a "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("mathematics requirement had fulfilled it three years later. “There are students taking these courses "), _c('a', {
    attrs: {
      "id": "ch2en22"
    }
  }), _vm._v("three, four, five times,” said Barbara Bonham of Appalachian State University. Even if some ultimately pass, she adds, “many drop out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Tennessee provides another dismal case, where over 70 percent of its college freshmen are consigned to remedial mathematics sections. They apparently find the experience so dispiriting that "), _c('a', {
    attrs: {
      "id": "ch2en23"
    }
  }), _vm._v("only five percent of them graduate on schedule. In 2013, a nonprofit research group called Complete College America issued a report called "), _c('i', [_vm._v("Remediation: Higher Education’s Road to Nowhere")]), _vm._v(". Its authors confirmed that “most students are "), _c('a', {
    attrs: {
      "id": "ch2en24"
    }
  }), _vm._v("placed on algebra pathways.” Yet, it suggested, a little thought would show that, instead of algebra, “statistics or quantitative mathematics would be most appropriate to prepare them for their chosen programs of study and careers.” Nor is this advice just for occupational preparation. Many two-year students opt for liberal arts fields, often to enhance their lives or become better citizens. Courses in statistics geared to their interests and needs would suit them better than algebra. Thus far this sensible proposal has found hardly any takers."), _c('sup', [_c('span', {
    staticClass: "khide"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/text/#apg20fn1"
    }
  }, [_vm._v("*")])])]), _c('sup', [_c('span', {
    staticClass: "ahide"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter02#kpg20fn1",
      "id": "krpg20fn1"
    }
  }, [_c('span', {
    staticClass: "foot1"
  }, [_vm._v("*")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "khide"
  }, [_c('aside', {
    attrs: {
      "epub:type": "footnote",
      "id": "apg20fn1"
    }
  }, [_vm._v("Is remedial work needed? It often is. In my introductory political science classes, I encounter far too many students who cannot write coherently. I would like to think this is being remedied in composition courses, since without that competence they can’t do college-level work. But it’s quite another thing to say that "), _c('i', [_vm._v("all")]), _vm._v(" undergraduates need advanced algebra to proceed toward their degrees.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Another study, this one by the National Center on Education and the Economy, found that “many community college students are "), _c('a', {
    attrs: {
      "id": "ch2en25"
    }
  }), _vm._v("denied a certificate or diploma, because they have failed in a mathematics course irrelevant to the work these students plan to do or the courses they need to take.” Marc Tucker, the report’s principal author, believes that algebra “is being used much "), _c('a', {
    attrs: {
      "id": "ch2en26"
    }
  }), _vm._v("as Latin was used a century ago, as a screen to keep the unwanted out of college.” Much of the blame rests with two-year faculties and administrators. Often on the defensive, and anxious to elevate their status, they try to show how rigorous they are by piling "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("on mathematics. They may get some professional points. But it’s their students who pay the price, often being forced out of education entirely.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("As will be shown in the next chapter, the kinds of mathematics taught in classrooms have little or no relevance, even in technical fields like electronic drafting. Lynn Arthur Steen is a rare mathematics professor willing to say this candidly. “What prospective employees lack is not calculus or college algebra,” he points out, “but more basic quantitative skills that "), _c('a', {
    attrs: {
      "id": "ch2en27"
    }
  }), _vm._v("could be taught in high school.”")]), _vm._v(" "), _c('p', {
    staticClass: "h3c"
  }, [_vm._v("COLLEGE DREAMS ARE DASHED")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("For over a century, the United States led the world in opening higher education to increasing numbers of its citizens. No other nation enacted anything like the Morrill Act of 1863 and the G.I. Bill of 1944 to put degrees within the reach of so many. Currently, over 60 percent of Americans give a two- or four-year "), _c('a', {
    attrs: {
      "id": "ch2en28"
    }
  }), _vm._v("college a try, if only for a semester. But the less heartening side, as previously noted, is that of the 2.5 million who sign up each September, almost half don’t finish. And they are a rather different set than those who didn’t complete high school. After all, they stuck it out for a high school diploma, demonstrating their capacity for academic work.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The greatest attrition is in the first year of college. Here, again, the primary academic cause is a mathematics requirement, all too often demanded of all students regardless of their prospective major. A City University of New York study of its mandated algebra course found that 57 percent of the students failed. In one of its member colleges, "), _c('a', {
    attrs: {
      "id": "ch2en29"
    }
  }), _vm._v("72 percent didn’t pass. The report calculated that the failure rate in mathematics was two and a half times greater than for the rest of the curriculum taken together. Here was its depressing conclusion: “failing mathematics affects retention more than any other academic factor.” It would be nice if that had sounded a wake-up call, but as of this writing those requirements are still in place.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("The most extensive data are from the Institute on Postsecondary Education, which examined transcripts containing "), _c('a', {
    attrs: {
      "id": "ch2en30"
    }
  }), _vm._v("over 265,000 grades at a cross section of colleges. For each course, it added up its failures, withdrawals, and incompletes. By this time, we shouldn’t be surprised to hear that nonpassing in mathematics was two to three times that for all other courses.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Almost a dozen countries now have a greater percentage of their population completing college than the United States does. Many of these countries require mathematics only for fields where it is rationally warranted. The United States has just as much nascent talent, but has instituted irrelevant requirements that bar many talented young people from higher education.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Most undergraduates don’t want to take mathematics, and few in freshman mathematics courses are there voluntarily. Compounding the problem, the teachers they meet in introductory sections are usually adjuncts or graduate assistants. Even experienced adjuncts tend to be overworked, with cramped office space, and are often rushing to another job. Teaching assistants are seldom counseled or supervised; more than a few nowadays are newly arrived in this country and made to teach as a condition of receiving a stipend. Suzanne Wilson of Michigan State University concluded that most mathematics faculties are not held accountable. Indeed, she found that "), _c('a', {
    attrs: {
      "id": "ch2en31"
    }
  }), _vm._v("when “a student fails a course, no mathematician is obliged to go back and help her learn what she did not understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Other fields try to make their first-year offerings interesting and appealing: no one is required to take anthropology. So if that department wants to recruit students to the discipline, it must make its introductory offerings attractive. “Few freshmen have even "), _c('a', {
    attrs: {
      "id": "ch2en32"
    }
  }), _vm._v("heard of anthropology,” Kevin Birth, its chairman at Queens College, told me. “While we in no way dumb it down, we show how our discipline can enhance their understanding of the world.” That’s not the attitude in mathematics. Some departments boast of “weeding out” pupils who don’t come with a commitment to the subject. Or they divide freshmen into “plums” "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("(the few deserving of faculty attention) and “prunes” (the majority, to be discarded). They can maintain this posture no matter what they do, because each year brings a new involuntary intake to bolster the departmental budget.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3c"
  }, [_vm._v("IVIED TOWERS")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The nation’s top-tier colleges revel in how many students they reject. In a recent year, "), _c('a', {
    attrs: {
      "id": "ch2en33"
    }
  }), _vm._v("29,610 applications poured in to Yale. Given all these folders, where does the admissions process start? The answer is to rank them by SAT scores, putting those with the 1600s—perfect scores in the verbal and mathematics sections—at the top of the pile. (Selective schools generally ignore the “writing” section.) Today, the elite colleges demand top ratings in "), _c('i', [_vm._v("both")]), _vm._v(" parts of the SAT. Harvard, Princeton, and Yale expect three-quarters of the students they accept to achieve a score of "), _c('a', {
    attrs: {
      "id": "ch2en34"
    }
  }), _vm._v("at least 700 in mathematics, a height reached by only nine percent of all men nationwide and only four of every hundred women. Stanford, Duke, and Dartmouth aren’t far behind, looking for a score of at least 680. Scores that high are also rare, achieved by only twelve percent of men and six percent of women. One result of such filters, to be explored more fully later, is that more women who are wholly qualified apart from mathematics find themselves being turned down.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("True, a quarter of those who are accepted are below the 700 cutoff. But it’s a safe bet that many of them are sought-after soccer players, or offspring of donors or alumni. Others are admitted under affirmative action, which includes not only ethnic backgrounds, but candidates from underrepresented states like Alaska and Montana. I am not suggesting that there’s anything wrong with being a top mathematics scorer. But Dartmouth and Duke aren’t Cal Tech and MIT. They are primarily liberal arts colleges, ostensibly committed to the breadth and depth of learning. Yet for three-quarters of the classes they admit, a very high mathematics showing is required, even for those planning to major in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("philosophy, classics, or modern dance, all of which are majors Ivy League and other elite colleges offer.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Even if technology and science are destined to loom larger than in the past, a lot more will be wanted and needed in our society. It’s unrealistic to expect that all the talents we want and need will always be found in tandem with mathematics. As a society, we had best be careful that we are not constricting—not to say contorting—our conception of excellence.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "h3v"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("VOICES")])]), _vm._v(" "), _c('figure', [_c('div', {
    staticClass: "image-container8"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "block8",
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/f0025-01.jpg",
      "width": "511"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "h3v"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("VOICES")])]), _vm._v(" "), _c('figure', [_c('div', {
    staticClass: "image-container7"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "block7",
    attrs: {
      "alt": "",
      "height": "509",
      "src": "images/f0026-01.jpg",
      "width": "468"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ahide"
  }, [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "2",
      "src": "images/line.jpg",
      "width": "110"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/text/Chapter02#krpg20fn1",
      "id": "kpg20fn1"
    }
  }, [_vm._v("*")])]), _vm._v("Is remedial work needed? It often is. In my introductory political science classes, I encounter far too many students who cannot write coherently. I would like to think this is being remedied in composition courses, since without that competence they can’t do college-level work. But it’s quite another thing to say that "), _c('i', [_vm._v("all")]), _vm._v(" undergraduates need advanced algebra to proceed toward their degrees.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b85902","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter02.vue
// module id = 81
// module chunks = 0